import { render, staticRenderFns } from "./InventoryTemplateDetailListComponent.vue?vue&type=template&id=005c5995&"
import script from "./InventoryTemplateDetailListComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryTemplateDetailListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports